module.exports = __webpack_public_path__ + "static/media/iguazu-title.11c89b8a.webp";